import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc); // Extension to use UTC as standard and time and then convert it into browser's local time

export default dayjs;



// Function to format numbers with commas for Western numbering system
export function formatNumberWithCommas(value: number | string): string {
  const numeric = Number(value);
  if (isNaN(numeric)) return '';

  return numeric.toLocaleString('en-IN'); // 'en-US' for western style
}